import { string, object, boolean, number } from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  return object({
    [`${formatName(properties['consent']?.$id as string)}`]: string()
      .required('Required')
      .max(10000, 'Must be at most 10000 characters'),
    [`${formatName(properties['id']?.$id as string)}`]: string()
      .required('Required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    [`${formatName(properties['required']?.$id as string)}`]: boolean(),
    [`${formatName(properties['gridSize']?.$id as string)}`]: number()
  });
};
